import { APICore } from "./apiCore";

const api = new APICore();

function ApiGetAllCompany(params: any): any {
  const baseUrl = "/api/admin/company";
  return api.get(`${baseUrl}`, params);
}

function ApiEditCompany(params: any): any {
  const baseUrl = "/api/admin/company/";
  return api.update(`${baseUrl}`, params);
}

function ApiPostCompany(params: any): any {
  const baseUrl = "/api/admin/create_company";
  // console.log('🚀 ~ ApiPostFasilitas ~ params:', params);
  return api.create(`${baseUrl}`, params);
}

export { ApiGetAllCompany, ApiPostCompany, ApiEditCompany };
